var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectspeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    d: "M13.5 0h-12C.675 0 .007.675.007 1.5L0 15l3-3h10.5c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5M12 9H3V7.5h9zm0-2.25H3v-1.5h9zm0-2.25H3V3h9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectspeech);
export default __webpack_public_path__ + "static/media/directspeech.ee0cf2fa2e1a6ae9e8d7a6c77a8f65c1.svg";
export { ForwardRef as ReactComponent };